// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';

import { validateCustomerName } from './customer-name';
import { validateCustomerEmail } from './customer-email';
import { validateAcceptsTerms } from './accept-terms';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({ spec, prsSupport, userInputName, userInputValue, userInputValues }: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'customerName':
      return onlyWhen('field_customer_name') && validateCustomerName(userInputValue);

    case 'customerEmail':
      return onlyWhen('field_customer_email') && validateCustomerEmail(userInputValue);

    case 'acceptTerms':
      return onlyWhen('field_accept_terms') && validateAcceptsTerms(userInputValue);

    default:
      return undefined;
  }
}
